export class AddressMhs {
    country?: string;
    line1: string;
    city: string;
    state: string;
    zip: string;
}